export default __webpack_public_path__ + "static/media/gallery_10.21837c2b.jpg";